import React,{useEffect, useState, useContext } from "react";
import additionalfn from "../../_additionalfn";
import { RenderContext } from "../Context/Ssr";
import { useWindowSize } from "./useWindowSize";

const CheckWindowResizeComponent = (props) => {
    const render = useContext(RenderContext);
    if (render.serverSide) {
        return;
    }
    const [deviceProperties, setDeviceProperties] = useState(additionalfn.getDeviceProperties());
    const windowSize = useWindowSize(350);

    useEffect(() => {
        setDeviceProperties(additionalfn.getDeviceProperties());
        document.dispatchEvent(new CustomEvent("CheckWindowResize", {
            detail: {
                properties: deviceProperties
            }
        }));
    },[windowSize])

    return(null);
}
export const CheckWindowResize = (initialProps, context) => {
    return (
        <CheckWindowResizeComponent { ...initialProps} />
    );
}